import script from "./FooterBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBottom.vue?vue&type=script&setup=true&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=3b5ec886&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5ec886"]])

export default __exports__